import {Action, ActionReducerMap} from '@ngrx/store';

import * as actionsUi from './veranstaltungselektion.actions.ui';
import {SetzeSelektierteVeranstaltungAction} from './veranstaltungselektion.actions.ui';
import {Veranstaltung} from '../../../clients/incidents';
import {GET_VERANSTALTUNGEN, GET_VERANSTALTUNGEN_ERFOLGREICH, GET_VERANSTALTUNGEN_FEHLER, GetVeranstaltungenErfolgreichAction} from '../../../client-ngrx/incidents';
import {VeranstaltungSelektionLocalData} from './veranstaltungselektion.model';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer,
};

export interface PageState {
    veranstaltungen: Array<Veranstaltung>;
    veranstaltungenLaden: boolean;
    veranstaltungenFehler: boolean;

    localData: VeranstaltungSelektionLocalData;
}

export const initialPageState: PageState = {
    veranstaltungen: [],
    veranstaltungenLaden: false,
    veranstaltungenFehler: false,

    localData: { selectedVeranstaltungsIds: [], nurVeranstaltungenMitOffenenIncidents: true }
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case actionsUi.SETZE_SELEKTIERTE_VERANSTALTUNG_IDS: {
            const a = <SetzeSelektierteVeranstaltungAction>action;

            const localData = Object.assign({}, state.localData, {selectedVeranstaltungsIds: a.payload});
            return Object.assign({}, state, <PageState>{
                localData
            });
        }

        case actionsUi.NUR_VERANSTALTUNGEN_MIT_OFFENEN_INCIDENTS: {
            const a = <actionsUi.NurVeranstaltungenMitOffenenIncidentsSetzenAction>action;

            const localData = Object.assign({}, state.localData, {nurVeranstaltungenMitOffenenIncidents: a.payload});

            return Object.assign({}, state, <PageState>{
                localData
            });
        }

        // Veranstaltungen
        case GET_VERANSTALTUNGEN: {
            return Object.assign({}, state, <PageState>{
                veranstaltungenLaden: true,
                veranstaltungenFehler: false
            });
        }

        case GET_VERANSTALTUNGEN_ERFOLGREICH: {
            const a = <GetVeranstaltungenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungenLaden: false,
                veranstaltungenFehler: false,
                veranstaltungen: a.payload
            });
        }

        case GET_VERANSTALTUNGEN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                veranstaltungenLaden: false,
                veranstaltungenFehler: true,
                veranstaltungen: []
            });
        }

        default: {
            return state;
        }
    }
}

